const ColorUtil = {
    hsvToRgb(h, s, v) {
        var r, g, b, i, f, p, q, t;
        if (arguments.length === 1) {
            s = h.s, v = h.v, h = h.h;
        }
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch (i % 6) {
            case 0: r = v, g = t, b = p; break;
            case 1: r = q, g = v, b = p; break;
            case 2: r = p, g = v, b = t; break;
            case 3: r = p, g = q, b = v; break;
            case 4: r = t, g = p, b = v; break;
            case 5: r = v, g = p, b = q; break;
        }
        return {
            r: Math.round(r * 255),
            g: Math.round(g * 255),
            b: Math.round(b * 255)
        };
    },
    rgbToHex(rgb) {
        return '#' + this.leadingZero(parseInt(rgb.r).toString(16)) +
          this.leadingZero(parseInt(rgb.g).toString(16)) + this.leadingZero(parseInt(rgb.b).toString(16));
    },
    rgbToHsv (r, g, b) {
        let rabs, gabs, babs, rr, gg, bb, h, s, v, diff, diffc, percentRoundFn;
        rabs = r / 255;
        gabs = g / 255;
        babs = b / 255;
        v = Math.max(rabs, gabs, babs),
        diff = v - Math.min(rabs, gabs, babs);
        diffc = c => (v - c) / 6 / diff + 1 / 2;
        percentRoundFn = num => Math.round(num * 100) / 100;
        if (diff == 0) {
            h = s = 0;
        } else {
            s = diff / v;
            rr = diffc(rabs);
            gg = diffc(gabs);
            bb = diffc(babs);
    
            if (rabs === v) {
                h = bb - gg;
            } else if (gabs === v) {
                h = (1 / 3) + rr - bb;
            } else if (babs === v) {
                h = (2 / 3) + gg - rr;
            }
            if (h < 0) {
                h += 1;
            }else if (h > 1) {
                h -= 1;
            }
        }
        return {
            h: parseFloat(h.toFixed(4)),
            s: percentRoundFn(s),
            v: percentRoundFn(v)
        };
    },
    hexToRgb(hex) {
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function(m, r, g, b) {
          return r + r + g + g + b + b;
        });
      
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16)
        } : null;
    },
    leadingZero(value) {
        if (value.length === 1) {
          value = '0' + value;
        }
        return value;
    },
    distance(a, b) {
        return Math.sqrt(Math.pow(a.r - b.r, 2) + Math.pow(a.g - b.g, 2) + Math.pow(a.b - b.b, 2));
    },
    findNearestColor(colorTable, h, s, v) {
        var lowest = Number.POSITIVE_INFINITY;
        var tmp;
        let index = 0;
        const compRGB = this.hsvToRgb(h, s, v);
        colorTable.forEach( (el, i) => {
            tmp = this.distance(compRGB, this.hexToRgb(el.hex))
            if (tmp < lowest) {
              lowest = tmp;
              index = i;
            };
        })
        return colorTable[index];
    },
    findNearestColorName(colorTable, h, s, v) {
        return this.findNearestColor(colorTable, h, s, v).name;
    },
    findNearestColorList(colorTable, h, s, v) {
        const compRGB = this.hsvToRgb(h, s, v);
        return colorTable.sort((lv, rv) => this.distance(compRGB, this.hexToRgb(lv.hex)) - this.distance(compRGB, this.hexToRgb(rv.hex)));
    }
};

export default ColorUtil;